import { notification } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListingAgreementNotification from '../components/ListingAgreement/ListingAgreementNotification';
import { getFundingSources } from '../services/AccountApi/paymentMethodApi';
import { resetLoginPin } from '../services/AccountApi/profileApi';
import { getAccountBalances } from '../services/InitialOfferings/initialOfferingSection';
import { fetchPropertyDetailsAction, updatePropertyDetails } from '../store/reducer/propertyDetailSlice';
import { secondarySellOrderBid, seondaryPlaceBidOrder } from '../store/reducer/secondaryQuickBuySlice';
import { toastNotify } from '../utils/toastNotify';
import { getUsCurrencyFormat } from '../utils/usCurrencyFormatter';

const useQuickBuySecondary = (modalState, quickBuyPropertyData, propertyDetailData = {}) => {
  const propertyDetails = useSelector((state) => state.propertyDetails.data);
  const [loading, setLoading] = useState(false);
  const [pin, setPin] = useState('');
  const [walletsData, setWalletsData] = useState([]);
  const [numberOfShare, setNumberOfShare] = useState('');
  const [resetPin, setResetPin] = useState(false);
  const [isTurmAndCondistion, setIsTurmAndCondistion] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({});
  const [isEditPayment, setIsEditPayment] = useState(false);
  const [limitPrice, setLimitPrice] = useState('');
  const [duration, setDuration] = useState('');
  const [partialFills, setPartialFills] = useState(true);
  const [activeTab, setActiveTab] = useState('1');
  const [userBalance, setUserBalance] = useState();
  const [selectedProperty, setSelectedProperty] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [storeOrderValue, setStoreOrderValue] = useState();
  const [openPinModal, setOpenPinModal] = useState(false);
  const [isTOSModal, setIsTOSModal] = useState(false);
  const [portfolioTOSModal, setPortfolioTOSModal] = useState(false);

  const dispatch = useDispatch();

  let LowestAskPrice = Number(propertyDetails?.data?.lowestAsk);
  let perSharePrice = Number(limitPrice);
  let userPurchasedShare = Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares);

  const totalInvestment = Number(limitPrice) * Number(numberOfShare) || 0;
  const sharesRemainingToPurchase = Math.floor(
    (
      (Number(propertyDetails?.data?.totalShare) * 9.8) / 100 -
      Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares) -
      Number(propertyDetails?.data?.requestedShares)
    ).toFixed(2)
  );
  const isMaxRangeError = Number(numberOfShare) > Number(sharesRemainingToPurchase);
  const minButtonValue =
    Number(propertyDetails?.data?.minimumPrice) / limitPrice === Infinity
      ? 0
      : Math.ceil(getUsCurrencyFormat(propertyDetails?.data?.minimumPrice / limitPrice));
  const isMinRangeError = Number(numberOfShare) < Number(minButtonValue);
  const transactionFee = getUsCurrencyFormat((Number(limitPrice) * Number(numberOfShare) * 1) / 100 || 0);
  const totalPurchase =
    activeTab === '1'
      ? Number(limitPrice) * Number(numberOfShare) + (Number(limitPrice) * Number(numberOfShare) * 1) / 100 + 2.5 || 0
      : (limitPrice && numberOfShare
          ? Number(limitPrice) * Number(numberOfShare) - (Number(limitPrice) * Number(numberOfShare) * 1) / 100 - 2.5
          : 0) || 0;
  useEffect(() => {
    setLimitPrice(getUsCurrencyFormat(propertyDetails?.data?.lastPrice?.toString()));
  }, [propertyDetails]);

  const handleFeatchOrderDetail = async () => {
    await dispatch(
      fetchPropertyDetailsAction({
        id: quickBuyPropertyData?.propertyId,
        onSuccess: () => {},
      })
    );
  };

  const handleFeatchBankDetail = async (value) => {
    try {
      const userData = await getFundingSources();
      if (!userData.isError) {
        setWalletsData(userData?.data?.wallets.concat(userData?.data?.banks).concat({ id: -1, brandName: 'Add new', sourceType: 'add new' }));
        setSelectedPaymentMethod(userData?.data?.wallets[0]);
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectPaymentMethod = (value) => {
    let matchedObject = walletsData?.find((item) => item.id === value);
    let updatedWallet = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Wallet');
    let updatedBank = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Bank');
    setWalletsData([matchedObject, ...updatedWallet, ...updatedBank, { id: -1, brandName: 'Add new', sourceType: 'add new' }]);
    setSelectedPaymentMethod(matchedObject);
    setIsEditPayment(false);
  };

  const handleFeatchDeatilSuccessfully = () => {
    modalState('StepTwo');
    setPin(undefined);
    setIsTurmAndCondistion(false);
    setNumberOfShare('');
    setLoading(false);
    setPartialFills(true);
    setDuration('');
    setLimitPrice();
  };

  const openTOSAgreementModal = () => {
    setIsTOSModal(true);
  };

  const onTOSAgreementSuccess = () => {
    setIsTOSModal(false);
    onPinVerifySuccess();
  };

  const onTOSModalClose = () => {
    setIsTOSModal(false);
  };

  const openPortfolioTOSModal = () => {
    setPortfolioTOSModal(true);
  };

  const onPortfolioTOSSuccess = () => {
    setPortfolioTOSModal(false);
    handleFeatchOpenOrderDetail(storeOrderValue);
  };

  const onPortfolioTOSClose = () => {
    setPortfolioTOSModal(false);
  };

  const handleAddBank = (value) => {
    let updatedWallet = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Wallet');
    let updatedBank = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Bank');
    setWalletsData([value.data, ...updatedWallet, ...updatedBank, { id: -1, brandName: 'Add new', sourceType: 'add new' }]);
    setSelectedPaymentMethod(value.data);
    isEditPayment(false);
  };
  const handleGetAccountBalances = async () => {
    try {
      const userData = await getAccountBalances();
      if (!userData.isError) {
        setUserBalance(userData?.data);
      }
    } catch (error) {}
  };
  const onPinVerifySuccess = async () => {
    walletsData.length <= 0 && handleFeatchBankDetail();
    Object.keys(propertyDetailData).length <= 0
      ? await dispatch(
          fetchPropertyDetailsAction({
            id: quickBuyPropertyData?.propertyId,
            onSuccess: () => handleFeatchDeatilSuccessfully(),
          })
        )
      : handleFeatchDeatilSuccessfully();
    handleGetAccountBalances();
  };

  const handleVerifyPin = async (isTOSAccepted = false) => {
    if (!isTOSAccepted) {
      modalState('');
      toastNotify(
        'newAgreement',
        <ListingAgreementNotification
          onBtnClick={() => {
            notification.close('newAgreement');
            openTOSAgreementModal();
          }}
        />
      );
    } else {
      onPinVerifySuccess();
    }
  };

  const handleVerifyPinOpenOrders = async (isTOSAccepted = false) => {
    if (!isTOSAccepted) {
      setOpenPinModal(false);
      toastNotify(
        'newAgreement',
        <ListingAgreementNotification
          onBtnClick={() => {
            notification.close('newAgreement');
            openPortfolioTOSModal();
          }}
        />
      );
    } else {
      setOpenPinModal(false);
      handleFeatchOpenOrderDetail(storeOrderValue);
    }
  };

  const handleFeatchOpenOrderDetail = async (selectedProperty) => {
    await dispatch(updatePropertyDetails({}));
    setSelectedProperty(selectedProperty);
    setOpenModal(true);
    await dispatch(
      fetchPropertyDetailsAction({
        id: selectedProperty?.propertyId,
      })
    );
  };

  const handleForgotPin = async () => {
    setLoading(true);
    try {
      const resData = await resetLoginPin();
      if (!resData.isError) {
        setOpenPinModal(false);
        toastNotify('success', resData?.message);
        modalState();
        setResetPin(true);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePlaceBid = async () => {
    if (Number(totalPurchase) < userBalance?.cash) {
      const bidData = {
        propertyId: quickBuyPropertyData?.propertyId?.toString(),
        fundingSourceId: selectedPaymentMethod?.id?.toString(),
        noOfShares: Number(numberOfShare),
        pricePerShare: Number(limitPrice),
        partialFills: partialFills,
        duration: duration,
      };
      await dispatch(seondaryPlaceBidOrder({ bidData, onSuccess: () => modalState('success') }));
    } else {
      const linkText = 'My Account>Account Balances';
      const linkPath = '/account/transactions';
      const openLink = () => {
        window.location.href = linkPath;
      };
      notification.error({
        description: (
          <div>
            <span style={{ cursor: 'pointer' }} onClick={openLink}>
              Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
            </span>
          </div>
        ),
        duration: 5,
      });
    }
  };

  const handleSellOrder = async () => {
    const bidData = {
      propertyId: quickBuyPropertyData?.propertyId?.toString(),
      fundingSourceId: selectedPaymentMethod?.id?.toString(),
      noOfShares: Number(numberOfShare),
      pricePerShare: Number(limitPrice),
      partialFills: partialFills,
      duration: duration,
    };
    await dispatch(secondarySellOrderBid({ bidData, onSuccess: () => modalState('success') }));
  };

  return {
    loading,
    pin,
    resetPin,
    numberOfShare,
    isMaxRangeError,
    isMinRangeError,
    minButtonValue,
    sharesRemainingToPurchase,
    limitPrice,
    LowestAskPrice,
    duration,
    totalInvestment,
    transactionFee,
    totalPurchase,
    isEditPayment,
    walletsData,
    selectedPaymentMethod,
    isTurmAndCondistion,
    partialFills,
    perSharePrice,
    userPurchasedShare,
    activeTab,
    propertyDetails,
    userBalance,
    selectedProperty,
    openModal,
    openPinModal,
    isTOSModal,
    setActiveTab,
    setPartialFills,
    setPin,
    handleVerifyPin,
    handleForgotPin,
    setResetPin,
    setNumberOfShare,
    setLimitPrice,
    setDuration,
    setIsEditPayment,
    handleSelectPaymentMethod,
    handleAddBank,
    setIsTurmAndCondistion,
    handlePlaceBid,
    handleSellOrder,
    handleFeatchOrderDetail,
    setSelectedProperty,
    setOpenModal,
    handleFeatchOpenOrderDetail,
    setStoreOrderValue,
    handleVerifyPinOpenOrders,
    setOpenPinModal,
    setPin,
    setLoading,
    onTOSAgreementSuccess,
    onTOSModalClose,
    portfolioTOSModal,
    onPortfolioTOSSuccess,
    onPortfolioTOSClose,
  };
};

export default useQuickBuySecondary;
